import React, { useEffect, useState } from 'react'
import { useForm , SubmitHandler } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { LogingFormData, LogInResponse } from '../../utils/Interface'
import eyes from '../../shared/images/Icon eyes.svg'
import style from '../../styles/components/form/LoginForm.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useLoginMutation } from '../../services/UserAPI'
import { setAuthData } from '../../store/slices/authSlice'
import { useTranslation } from 'react-i18next';
const LoginForm: React.FC = () => {
    const { t, i18n  } = useTranslation();
    const { register, handleSubmit, getValues } = useForm<LogingFormData>()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    // - State
    const [submitted, setSubmitted] = useState(false)
    const [type, setType] = useState('password')
    const [inputContainerClass, setInputContainerClass] = useState(
        style.InputContainer
    )
    const [emailFocused, setEmailFocused] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [passwordFocused, setPasswordFocused] = useState(false)

    // useLoginMutation hook
    const [loginUser, { isLoading, isError, isSuccess }] = useLoginMutation()

    // - UseEffect
    useEffect(() => {
        if (submitted && isError) {
            setInputContainerClass(style.InputContainer + ' ' + style.Rejected)
        } else {
            setInputContainerClass(style.InputContainer)
        }
    }, [submitted, isError])

    // - Form event
    const handleToggle = () => {
        setType((prevType) => (prevType === 'password' ? 'text' : 'password'))
    }

    const onSubmit = async (formData: LogingFormData) => {
        setSubmitted(true)
        try {
            const result: { data: LogInResponse } = (await loginUser(
                formData
            )) as { data: LogInResponse }
            console.log('Login successful:', result)
            if (result.data.status === "success") {
                dispatch(
                    setAuthData({
                        jwt: result.data.jwt,
                        user: result.data.user,
                        reservations: result.data.reservations,
                        currentResId: formData.asterioId
                    })
                )
                console.log('user : ', result.data.user)
                console.log('Connected')
                navigate('/mon-compte') // Rediriger l'utilisateur
            }
            else if (result.data.status === "error"){
                setErrorMessage(String(result?.data?.error))
            }
            // TODO: Handle successful login (e.g., redirect, store user info)
        } catch (error : any) {
            console.error('Failed to login:', error)
        }
    }

    return (
        <>
            {/* If a different visual or a popup is requested depending on the state of the form, it can be handled as follows */}
            {/*{submitted && loginState === 'pending' && <div>Pending...</div>}
            {submitted && loginState === 'fulfilled' && <div>Login successful!</div>}*/}

            <form onSubmit={handleSubmit(onSubmit)} className={style.LoginForm}>
                {submitted && isError && (
                    <h3 className={style.TitleInputError}>
                        {errorMessage}
                    </h3>
                )}
                <div
                    className={`${inputContainerClass} ${
                        emailFocused || getValues('identifier') ? style.Filled : ''
                    }`}>
                    <input
                        type='email'
                        id='email'
                        {...register('identifier', { required: true })}
                        required
                        onFocus={() => setEmailFocused(true)}
                        onBlur={() => setEmailFocused(false)}
                    />
                    <label htmlFor='email'>{t('your_email')}</label>
                </div>
                <div
                    className={`${inputContainerClass} ${
                        passwordFocused || getValues('asterioId')
                            ? style.Filled
                            : ''
                    }`}>
                    <input
                        type='text'
                        id='asterioId'
                        {...register('asterioId', { required: true })}
                        required
                        onFocus={() => setPasswordFocused(true)}
                        onBlur={() => setPasswordFocused(false)}
                    />
                    <label htmlFor='asterioId'>{t('your_resa')}</label>
                    {/*<img
                        src={eyes}
                        alt='Eyes'
                        className={style.PasswordIcon}
                        onClick={handleToggle}
                    />*/}
                </div>
                {/*<br />
                <Link to='../mot-de-passe-oublie'>Mot de passe oublié ?</Link>*/}
                <br />
                <button className={style.loginButton} type='submit' disabled={isLoading}>
                    {isLoading ? t('loading') + '...' : t('connect')}
                </button>
                {/*<div className={style.or}>OU</div>
                submitted && isSuccess && <div>Login successful!</div>
                <button className={style.createButton}>Créer un compte</button>*/}
                
            </form>
        </>
    )
}

export default LoginForm